import { useCallback } from 'react'
import { Status } from 'civic-champs-shared/api/hooks'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { EventPayload } from 'Event/helpers/add-edit-helpers'
import { OpportunityResponseWithRecurrenceInfo } from 'Event/interfaces/interfaceCreateEditEvent'
import useThrottledCallback from 'utils/useThrottledCallback'

export const useUpdateSchedulableOpportunity = (): [
  (body: EventPayload, encodedOccurrence: string, isDraft?: boolean) => Promise<OpportunityResponseWithRecurrenceInfo>,
  Status<OpportunityResponseWithRecurrenceInfo>,
] => {
  const [request, status] = useFetchRefactored<OpportunityResponseWithRecurrenceInfo>({ disableRetry: true })

  const updateSchedulableOpportunity = useThrottledCallback(
    (body: EventPayload, encodedOccurrence: string, isDraft: boolean = false) => {
      return request({
        method: 'put',
        url: `/opportunity_instances/${encodedOccurrence}/${isDraft ? 'draft' : 'publish'}`,
        config: {
          body,
        },
      })
    },
    500,
    [request],
  )

  return [updateSchedulableOpportunity, status]
}

export default useUpdateSchedulableOpportunity
